import { render, staticRenderFns } from "./MapIconPerekrestok.vue?vue&type=template&id=0c061b7e&scoped=true&"
import script from "./MapIconPerekrestok.vue?vue&type=script&lang=js&"
export * from "./MapIconPerekrestok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c061b7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c061b7e')) {
      api.createRecord('0c061b7e', component.options)
    } else {
      api.reload('0c061b7e', component.options)
    }
    module.hot.accept("./MapIconPerekrestok.vue?vue&type=template&id=0c061b7e&scoped=true&", function () {
      api.rerender('0c061b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconPerekrestok.vue"
export default component.exports